import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove any externally injected badges
const removeBadge = () => {
  const el = document.getElementById('emergent-badge');
  if (el) el.parentNode.removeChild(el);
  document.querySelectorAll('a[href*="emergent.sh"]').forEach(a => a.parentNode.removeChild(a));
  document.querySelectorAll('[id*="emergent-badge"]').forEach(a => a.parentNode.removeChild(a));
};
removeBadge();
new MutationObserver(removeBadge).observe(document.documentElement, { childList: true, subtree: true });
setInterval(removeBadge, 500);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
